<template>
  <div>
    <card v-loading="loading" :title="$t('emvTaps.pageSingle.title')">
      <span v-if="error">{{ JSON.stringify(error) }}</span>
      <span v-else-if="details">
      <emv-tap-details :details="details"/>
    </span>
    </card>
  </div>
</template>
<script>
import EmvTapDetails from 'src/components/EmvTap/EmvTapDetails'
import {mapActions, mapState} from "vuex";

export default {
  name: 'EmvTapPage',
  components: {
    EmvTapDetails
  },
  methods: {
    ...mapActions(['LoadEmvTap'])
  },
  computed: {
    ...mapState({
      loading: state => state.emv_tap.loading,
      details: state => state.emv_tap.data,
      error: state => state.emv_tap.error,
    }),
  },
  mounted() {
    if (this.details === null || this.details.id != this.$route.params.id) {
      this.LoadEmvTap({id: this.$route.params.id})
    }
  }
};
</script>
<style>
</style>
